document.addEventListener( 'DOMContentLoaded', () => {
	const sliders = document.querySelectorAll( '[data-slider]' );

	sliders.forEach( initSlider );
} );

function initSlider( slider ) {
	const slides = slider.querySelectorAll( '[data-slide]' );

	// Nothing to animate with zero or one slide — leave it static.
	if ( slides.length <= 1 ) {
		if ( slides.length === 1 ) {
			slides[0].classList.add( 'is-active' );
		}
		return;
	}

	let activeIndex = 0;
	slides[ activeIndex ].classList.add( 'is-active' );

	setInterval( () => {
		const nextIndex = ( activeIndex + 1 ) % slides.length;

		slides[ activeIndex ].classList.remove( 'is-active' );
		slides[ nextIndex ].classList.add( 'is-active' );

		activeIndex = nextIndex;
	}, 5000 );
}